import { ActivityEventDto } from '../../../shared/modules/activity/dtos/activity-event.dto';
import { SupplierActivityEventHydration } from './supplier-activity-event-hydration.dto';

/**
 * A supplier activity event with hydrated related records.
 */
export class SupplierActivityEventDto extends ActivityEventDto {
  hydrated?: SupplierActivityEventHydration;
}
